import { httpRequest } from "@/utils/HttpRequest";
import { ciHttpRequest } from "@/utils/CiHttpRequest";
import { IKey, IMdCmFields, IPage, ISearchPageField } from "@/types/FmsTypes";
import { trasDsToTreeData } from "../dict/dictModel";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

export interface IMdOrgFields extends IMdCmFields {

  code?: string;
  name?: string;
  pcode?: string;
  contact?: string;
  phone?: string;
  address?: string;
  note?: string;
  children?: IMdOrgDetail[];
}

export type IMdOrgDetail = IKey & IMdCmFields & IMdOrgFields;
export type IMdOrgSearch = IMdOrgFields & ISearchPageField;

export interface CiOrgan {
  id: string,
  traceId: string,
  orderCodePrefix: string,
  mdShopId: string,
  organType: number,
  organStatus: number,
  organBelong: string,
  organCode: string,
  organName: string,
  organContactName: string,
  organContactPhone: string,
  organContactAddress: string,
  organProvince: string,
  organCity: string,
  organDistrict: string,
  organLng: string,
  organLat: string,
  organNature: number,
  autoDispatch: number,
  allowTransfer: number,
  businessEntityCode: string,
  businessEntityName: string,
  shopCode: string,
  shopName: string,
  repairNumber: string,
  vehicleNumber: string,
  siteArea: string,
  warehouseArea: string,
  serviceBrand: string,
  threeGuaranteesBrand: string,
  serviceArea: string,
  companyName: string,
  companyCode: string,
  legalPersonName: string,
  legalPersonPhone: string,
  businessLicense: string,
  idcardHead: string,
  idcardTail: string,
  defBusinessManager: string,
  ciBusinessEntityId: string,
  ciBusinessEntityName: string
}

class OrgService {
  async insert(insertVo: IMdOrgFields) {
    const apiUrl = "/org/insert";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, insertVo);
  }

  async disable(oneVo: IMdOrgFields) {
    const apiUrl = "/org/disable";
    return await httpRequest.post<boolean>(apiUrl, oneVo)
  }

  async find(searchVo: IMdOrgFields) {
    const apiUrl = "/org/find";
    return await httpRequest.post<IMdOrgDetail[]>(apiUrl, searchVo)
  }

  async orgDs(pcode: string) {
    let { retData } = await this.find({ pcode })
    return retData.map(el => ({
      label: el.name,
      value: el.code
    }));
  }

  async page(searchVo: IMdOrgSearch) {
    const apiUrl = "/org/page";
    return await httpRequest.post<IPage<IMdOrgDetail>>(apiUrl, searchVo)
  }

  async one(oneVo: IMdOrgFields) {
    const apiUrl = "/org/one";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, oneVo)
  }

  async allTree(vo: IMdOrgFields) {
    const apiUrl = "/org/allTree";
    vo.branchList = ["main", "fms"];
    return await httpRequest.post<IMdOrgDetail[]>(apiUrl, vo)
  }


  async oneTree(oneVo: IMdOrgFields) {
    const apiUrl = "/org/oneTree";
    return await httpRequest.post<IMdOrgDetail>(apiUrl, oneVo)
  }

  async sync(syncVo: IMdOrgFields) {
    const apiUrl = "/org/sync";
    syncVo.branchList = ["main", "fms"];
    return await httpRequest.post<boolean>(apiUrl, syncVo, { timeout: LONG_REQUEST_TIMEOUT })
  }

  async syncPage(searchVo: IMdOrgSearch) {
    const apiUrl = "/org/syncPage";
    searchVo.branchList = ["main", "fms"];
    return await httpRequest.post<boolean>(apiUrl, searchVo)
  }

  async syncOne(oneVo: IMdOrgFields) {
    const apiUrl = "/org/syncOne";
    return await httpRequest.post<boolean>(apiUrl, oneVo)
  }

  async orgTreeDs(vo: IMdOrgFields) {
    let { retData } = await this.allTree(vo);
    // retData.map(el=>({
    //     label:el.name,
    //     value:el.code,
    //     children:[]
    // }))
    let treeData = trasDsToTreeData(retData, "code", "name");
    return treeData;
  }

  //根据shopid查询云创机构
  async getByShopId(shopId: string) {
    const apiUrl = `/ci-platform/organ/getByShopId/${shopId}`;
    return await ciHttpRequest.get<CiOrgan>(apiUrl);
  }

}

export const orgService = new OrgService();
